import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";

// SMART LOGIC : Otomatis pilih Localhost atau Server IP
const API_BASE = process.env.REACT_APP_API_BASE;
// const API_BASE = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
//   ? "http://localhost:3000"       // Kalau lagi development
//   : "http://151.106.120.16:3000"; // Kalau nanti dideploy

const ADMIN_EMAILS = ["alfa271200@gmail.com"];

export default function ProtectedRoute({ children, adminOnly = false }) {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    // 1. Kalau gak ada token, langsung tolak
    if (!token) {
      setIsAuth(false);
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    // Cek admin dari localStorage
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsed = JSON.parse(storedUser);
        const email = (parsed.email || "").toLowerCase();
        setIsAdmin(ADMIN_EMAILS.includes(email));
      }
    } catch (e) {
      setIsAdmin(false);
    }

    // 2. Kalau ada token, TANYA KE BACKEND: "Valid gak?"
    axios
      .get(`${API_BASE}/auth/verify-token`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // Backend bilang OK (200)
        setIsAuth(true);
      })
      .catch((err) => {
        // Backend bilang Gagal (401/403)
        console.error("Token expired or invalid:", err);
        localStorage.removeItem("token"); // Hapus token busuk
        setIsAuth(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="flex h-screen items-center justify-center">Verifying session...</div>;

  if (!isAuth) {
    // Tendang ke login, simpan lokasi terakhir biar user friendly
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return (
      <div className="flex flex-col h-screen items-center justify-center bg-slate-50 text-center px-4">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 max-w-md">
          <div className="w-16 h-16 bg-red-100 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">Akses Ditolak</h2>
          <p className="text-slate-600 mb-6">
            Halaman ini khusus untuk Administrator. Akun Anda saat ini belum memiliki akses ke fitur ini. Silakan hubungi tim support untuk request akses.
          </p>
          <button 
            onClick={() => window.history.back()}
            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-xl transition-colors"
          >
            Kembali
          </button>
        </div>
      </div>
    );
  }

  return children;
}
